import React, { useEffect, useRef } from 'react';
import { get, isEmpty } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { fetchWorkBookQuestion } from '../../../../actions/raceAndExerciseActions';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Button from '@material-ui/core/Button';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import PropTypes from 'prop-types';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import './styles.scss';
import useWindowDimensions from '../../../../components/Dimension';
import { Skeleton } from '@material-ui/lab';

export default function QuestionSolution(props) {
  // Variables
  const workBook = props.workBook;
  const selectedItems = props.selectedItems;
  const sliderRef = useRef(null);
  const divRef = useRef(null);
  const [isFetching, setIsFeching] = React.useState(false);

  //window height
  const { height } = useWindowDimensions();
  // Redux
  const dispatch = useDispatch();

  const jwt = useSelector((state) => get(state, 'loginReducer.data.jwt', ''));

  const workbookData = useSelector((state) =>
    get(state, 'raceAndExerciseReducer.workbookData', [])
  );

  useEffect(() => {
    setIsFeching(true);
    fetchWorkBookQuestion(workBook, jwt, dispatch).then(() => {
      setIsFeching(false);
    });
  }, []);

  const next = () => {
    sliderRef.current.slickNext();
    divRef.current.scrollIntoView();
  };
  const prev = () => {
    sliderRef.current.slickPrev();
    divRef.current.scrollIntoView();
  };

  const getQuestionSolutionSlider = () => {
    let whenLoading = [1, 1, 1, 1];
    const sliderImage = [];
    var settings = {
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      arrows: false,
      adaptiveHeight: true,
      fade: true,
    };
    (isFetching
      ? whenLoading
      : workbookData &&
        workbookData.listQuestion &&
        workbookData.listQuestion.length &&
        workbookData.listQuestion
    ).map((data, index) => {
      if (isFetching) {
        sliderImage.push(
          <Skeleton className="slide" key={index} height={'20px'} />
        );
      } else {
        sliderImage.push(
          <div className="slide" key={index}>
            <div className="counts" ref={divRef}>
              <span className="q-count">
                {data.QuestionNo.length && data.QuestionNo.length < 2
                  ? ('0' + data.QuestionNo).slice(-2)
                  : data.QuestionNo}
              </span>
              <span className="q-total ml-10">
                of {workbookData.listQuestion.length}
              </span>
            </div>
            <div className="question-slide">
              <img
                src={data.SolutionImage}
                alt={data.QuestionNo}
                className="img-responsive"
              />
            </div>
          </div>
        );
      }
    });
    if (isFetching) return sliderImage;
    else {
      return (
        <Slider ref={!isFetching ? sliderRef : null} {...settings}>
          {sliderImage}
        </Slider>
      );
    }
  };

  return (
    <React.Fragment>
      {isFetching ? (
        <Skeleton className="selected-item-list" width={'40%'} />
      ) : (
        <div className="selected-item-list">
          <ul>
            <li>
              <span>{selectedItems.workBook}</span>
            </li>
            <li>
              <span> {selectedItems.subject}</span>
            </li>
            <li>
              <span>{selectedItems.topic}</span>
            </li>
            <li>
              <span>
                {selectedItems.exercise} ({workbookData.WorkBookCode})
              </span>
            </li>
          </ul>
        </div>
      )}
      <div className="slider-wrapper" style={{ height: height - 200 }}>
        <PerfectScrollbar>
          {!isEmpty(workbookData) &&
            workbookData.listQuestion &&
            workbookData.listQuestion.length > 0 &&
            getQuestionSolutionSlider()}
        </PerfectScrollbar>
      </div>
      <div className="footer-container">
        <Button
          variant="contained"
          className="footer-buttons"
          onClick={() => prev()}
          disabled={isFetching}
        >
          {isFetching ? (
            <Skeleton width={'100%'} />
          ) : (
            <React.Fragment>
              <ArrowBackIosIcon style={{ fontSize: 12 }} /> Previous
            </React.Fragment>
          )}
        </Button>
        <Button
          variant="contained"
          className="footer-buttons"
          onClick={() => next()}
          disabled={isFetching}
        >
          {isFetching ? (
            <Skeleton width={'100%'} />
          ) : (
            <React.Fragment>
              Next <ArrowForwardIosIcon style={{ fontSize: 12 }} />
            </React.Fragment>
          )}
        </Button>
      </div>
    </React.Fragment>
  );
}

QuestionSolution.propTypes = {
  workBook: PropTypes.number,
  selectedItems: PropTypes.object,
};
